import { render, staticRenderFns } from "./MapFactor.vue?vue&type=template&id=85b51e18&"
import script from "./MapFactor.vue?vue&type=script&lang=js&"
export * from "./MapFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports